import { render, staticRenderFns } from "./StadiumFieldUpdateForm.vue?vue&type=template&id=ffd0a816&"
import script from "./StadiumFieldUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumFieldUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports